import workflow from './workflow'

const state = {
}


const getters = {

}


const mutations = {

}


const actions = {


}

export default {
  namespaced: true,
  modules: {
    workflow
  },
  state,
  getters,
  mutations,
  actions
}